import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { SEOHead } from '../components/SEOHead';
import TestimonialSlider from '../components/TestimonialSlider';
import Marquee from '../components/Marquee';
import { PrijzenBanner } from '../components/PageBanners';
import { CheckCircle, X, ArrowRight, Star, Zap } from 'lucide-react';

const FEATURES = [
  {
    category: 'Algemeen',
    items: [
      { name: 'Gratis groeiscan', free: true, paid: true },
      { name: 'Persoonlijk groeidashboard', free: true, paid: true },
      { name: 'Groeiscore (0-100)', free: true, paid: true },
      { name: 'Maandelijkse monitoring', free: false, paid: true },
      { name: 'E-mail alerts & meldingen', free: false, paid: true },
      { name: 'Wekelijkse rapportage', free: false, paid: true },
    ]
  },
  {
    category: 'Brand Monitoring',
    items: [
      { name: 'Notificatie feed', free: true, paid: true },
      { name: 'Concurrenten volgen', free: '3', paid: '10' },
      { name: 'Realtime meldingen', free: false, paid: true },
      { name: 'Merkvermelding monitoring', free: false, paid: true },
    ]
  },
  {
    category: 'Zoekmachineoptimalisatie (SEO)',
    items: [
      { name: 'SEO video opdrachten op maat', free: true, paid: true },
      { name: 'Zoekwoord tracking', free: '5', paid: '50' },
      { name: 'Gedetailleerde SEO rapporten', free: false, paid: true },
      { name: 'SEO Tekst Optimalisator', free: false, paid: true },
      { name: 'Google Analytics integratie', free: true, paid: true },
      { name: 'Subpagina analyse', free: false, paid: true },
    ]
  },
  {
    category: 'Online Aanwezigheid',
    items: [
      { name: 'Google Bedrijfsprofiel integratie', free: true, paid: true },
      { name: 'Bedrijfsgidsen controleren (46+)', free: true, paid: true },
      { name: 'Automatisch publiceren in gidsen', free: false, paid: true },
      { name: 'Bescherming van vermeldingen', free: false, paid: true },
      { name: 'Lokale ranking inzichten', free: false, paid: true },
    ]
  },
  {
    category: 'Google Ads',
    items: [
      { name: 'Ads kansen & suggesties', free: true, paid: true },
      { name: 'Campagne creator', free: false, paid: true },
      { name: 'Budget controle & transparantie', free: false, paid: true },
      { name: 'Uitgebreide ads rapporten', free: false, paid: true },
    ]
  },
  {
    category: 'Online Reputatie & Reviews',
    items: [
      { name: 'Review overzicht', free: true, paid: true },
      { name: 'Reageren op reviews', free: false, paid: true },
      { name: 'Persoonlijke assistent voor reviewantwoorden', free: false, paid: true },
      { name: 'Reputatie benchmark met branche', free: false, paid: true },
      { name: 'Review-historie & analytics', free: false, paid: true },
    ]
  },
  {
    category: 'Social Media',
    items: [
      { name: 'Facebook & Instagram koppeling', free: true, paid: true },
      { name: 'Social media monitoring', free: false, paid: true },
      { name: 'Berichten plannen & publiceren', free: false, paid: true },
      { name: 'Social media prestaties volgen', free: false, paid: true },
    ]
  },
  {
    category: 'Uitvoering door IMPERIA AI',
    items: [
      { name: 'Eenmalige optimalisaties afnemen', free: false, paid: true },
      { name: 'Maandelijkse groeipakketten', free: false, paid: true },
      { name: 'Leads kopen', free: false, paid: true },
      { name: 'Website laten bouwen', free: false, paid: true },
    ]
  },
];

const MARQUEE_FEATURES = [
  { icon: '🔍', text: 'SEO Monitoring' },
  { icon: '📍', text: 'Lokale Vindbaarheid' },
  { icon: '⭐', text: 'Review Management' },
  { icon: '📊', text: 'Google Analytics' },
  { icon: '🎯', text: 'Google Ads' },
  { icon: '📱', text: 'Social Media' },
  { icon: '🤖', text: 'AI Assistent' },
  { icon: '🏆', text: 'Brand Monitoring' },
  { icon: '🌐', text: 'Bedrijfsgidsen' },
  { icon: '📈', text: 'Groeirapportages' },
];

const Cell = ({ val }) => {
  if (val === true) return <CheckCircle className="w-5 h-5 text-[#D4A017] mx-auto" />;
  if (val === false) return <X className="w-4 h-4 text-gray-300 mx-auto" />;
  return <span className="text-[#0f172a] font-bold text-sm">{val}</span>;
};

export default function PrijsPage() {
  const [billing, setBilling] = useState('yearly');
  const [openCat, setOpenCat] = useState(null);

  const price = billing === 'yearly' ? '€99,95' : '€14,95';
  const period = billing === 'yearly' ? '/ jaar' : '/ maand';
  const monthly_equiv = billing === 'yearly' ? '€8,33 per maand' : null;

  return (
    <>
      <SEOHead
        title="Prijzen — Gratis of IMPERIA AI Radar | IMPERIA AI"
        description="Kies uw plan: gratis groeiscan met dashboard of volledige toegang met IMPERIA AI Radar voor €14,95/mnd of €99,95/jaar. Geen creditcard voor de gratis versie."
        keywords="imperia ai radar prijs, online marketing abonnement, groeiscan prijs, seo monitoring prijs"
        canonical="/prijs"
      />

      <PrijzenBanner billing={billing} setBilling={setBilling} />

      {/* Marquee */}
      <Marquee items={MARQUEE_FEATURES} dark />

      {/* Pricing cards */}
      <section className="bg-[#f8fafc] py-14 md:py-16">
        <div className="container-custom max-w-4xl mx-auto">
          <div className="grid md:grid-cols-2 gap-6">

            {/* Gratis */}
            <div className="bg-white rounded-2xl border border-gray-200 p-8 flex flex-col">
              <div className="mb-6">
                <p className="text-[#64748b] text-xs font-bold uppercase tracking-wider mb-2">GRATIS</p>
                <p className="text-5xl font-bold text-[#0f172a] mb-1">€0</p>
                <p className="text-[#94a3b8] text-sm">Voor altijd gratis · Geen creditcard</p>
              </div>
              <Link to="/register"
                className="block text-center border-2 border-[#0f172a] text-[#0f172a] font-bold py-3.5 rounded-xl mb-8 hover:bg-[#0f172a] hover:text-white transition-all">
                Begin nu
              </Link>
              <div className="space-y-2.5 flex-1">
                {['Gratis groeiscan', 'Persoonlijk dashboard', 'Groeiscore (0-100)', '3 kritieke aandachtspunten', '3 quick wins', '5 zoekwoorden tracking', 'Google Bedrijfsprofiel check', 'Bedrijfsgidsen check'].map(f => (
                  <div key={f} className="flex items-center gap-3 text-[#64748b] text-sm">
                    <CheckCircle className="w-4 h-4 text-[#94a3b8] flex-shrink-0" />{f}
                  </div>
                ))}
              </div>
            </div>

            {/* IMPERIA AI Radar */}
            <div className="rounded-2xl p-8 relative overflow-hidden flex flex-col"
              style={{ background: 'linear-gradient(145deg, #0f172a, #1e1b4b)' }}>
              <div className="absolute top-4 right-4 bg-[#D4A017] text-[#0f172a] text-xs font-bold px-3 py-1.5 rounded-full flex items-center gap-1">
                <Star className="w-3 h-3 fill-current" /> MEEST GEKOZEN
              </div>
              <div className="mb-6">
                <div className="flex items-center gap-2 mb-2">
                  <Zap className="w-4 h-4 text-[#D4A017]" />
                  <p data-testid="pricing-radar-brand" className="text-[#D4A017] text-xs font-bold uppercase tracking-wider">IMPERIA AI RADAR</p>
                </div>
                <p className="text-5xl font-bold text-white mb-1">{price}</p>
                <p className="text-white/50 text-sm">{period} · excl. BTW</p>
                {monthly_equiv && <p className="text-[#D4A017] text-sm font-semibold mt-1">{monthly_equiv}</p>}
              </div>
              <Link to="/register"
                className="block text-center font-bold py-3.5 rounded-xl mb-8 transition-all"
                style={{ background: 'linear-gradient(135deg, #D4A017, #f5c842)', color: '#0f172a' }}>
                Verdergaan met Radar
              </Link>
              <div className="space-y-2.5 flex-1">
                <div className="text-[#D4A017] text-sm font-bold mb-3">Alle voordelen van Gratis, plus:</div>
                {['Alle analyses ontgrendeld', 'Maandelijkse monitoring', '50 zoekwoorden tracking', 'Tekst Optimalisator', 'SEO opdrachten op maat', 'Reviews beheren + AI antwoorden', 'Social media monitoring', 'Wekelijkse rapportages', 'Stap-voor-stap verbeterinstructies', 'Uitvoering door IMPERIA AI afnemen'].map(f => (
                  <div key={f} className="flex items-center gap-3 text-white/80 text-sm">
                    <CheckCircle className="w-4 h-4 text-[#D4A017] flex-shrink-0" />{f}
                  </div>
                ))}
              </div>
            </div>
          </div>

          <p className="text-center text-[#94a3b8] text-xs mt-6">
            Jaarlijks abonnement wordt automatisch verlengd · Maandelijks opzegbaar bij maandabonnement
          </p>
        </div>
      </section>

      {/* Feature comparison table */}
      <section className="bg-white py-14 md:py-16">
        <div className="container-custom max-w-4xl mx-auto">
          <div className="text-center mb-10">
            <p className="text-xs font-bold uppercase tracking-widest text-[#D4A017] mb-3">Vergelijk plannen</p>
            <h2 className="font-serif text-3xl font-bold text-[#0f172a]">Alle functies vergeleken</h2>
          </div>

          {/* Table header */}
          <div className="grid grid-cols-3 bg-[#0f172a] rounded-t-2xl">
            <div className="p-4 col-span-1">
              <p className="text-white/50 text-sm">Functie</p>
            </div>
            <div className="p-4 text-center border-l border-white/10">
              <p className="text-white font-semibold text-sm">Gratis</p>
            </div>
            <div className="p-4 text-center border-l border-white/10">
              <p className="text-[#D4A017] font-bold text-sm">IMPERIA AI Radar</p>
              <p className="text-white/50 text-xs">{price}{period}</p>
            </div>
          </div>

          {FEATURES.map((cat, ci) => (
            <div key={cat.category}>
              {/* Category header */}
              <button onClick={() => setOpenCat(openCat === ci ? null : ci)}
                className="w-full grid grid-cols-3 bg-[#f8fafc] border-b border-gray-100 hover:bg-gray-100 transition-colors">
                <div className="p-4 col-span-3 text-left font-bold text-[#0f172a] text-sm flex items-center justify-between">
                  {cat.category}
                  <span className="text-[#94a3b8] text-xs">{openCat === ci ? '▲' : '▼'}</span>
                </div>
              </button>

              {/* Category rows */}
              {(openCat === ci || openCat === null) && cat.items.map((item, ii) => (
                <div key={ii} className="grid grid-cols-3 border-b border-gray-100 hover:bg-gray-50 transition-colors">
                  <div className="p-4 text-[#64748b] text-sm col-span-1">{item.name}</div>
                  <div className="p-4 text-center border-l border-gray-100 flex items-center justify-center">
                    <Cell val={item.free} />
                  </div>
                  <div className="p-4 text-center border-l border-gray-100 flex items-center justify-center bg-[#D4A017]/3">
                    <Cell val={item.paid} />
                  </div>
                </div>
              ))}
            </div>
          ))}

          {/* Bottom CTA row */}
          <div className="grid grid-cols-3 bg-[#f8fafc] rounded-b-2xl border border-gray-100">
            <div className="p-5 col-span-1" />
            <div className="p-5 text-center border-l border-gray-100">
              <Link to="/register" className="inline-block border-2 border-[#0f172a] text-[#0f172a] font-bold px-5 py-2.5 rounded-xl text-sm hover:bg-[#0f172a] hover:text-white transition-all">
                Begin gratis
              </Link>
            </div>
            <div className="p-5 text-center border-l border-gray-100">
              <Link to="/register"
                className="inline-block font-bold px-5 py-2.5 rounded-xl text-sm transition-all"
                style={{ background: 'linear-gradient(135deg, #D4A017, #f5c842)', color: '#0f172a' }}>
                Start Radar
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials slider */}
      <section style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e1b4b 100%)' }} className="py-14 md:py-16">
        <div className="container-custom">
          <div className="text-center mb-10">
            <p className="text-xs font-bold uppercase tracking-widest text-[#D4A017] mb-3">
              Onze klanten zeggen: <span className="text-white">Uitstekend</span>
              {[...Array(5)].map((_, i) => <Star key={i} className="inline w-4 h-4 text-[#D4A017] fill-[#D4A017] ml-0.5" />)}
            </p>
            <h2 className="font-serif text-3xl font-bold text-white">Wat onze klanten zeggen</h2>
          </div>
          <TestimonialSlider dark />
        </div>
      </section>

      {/* Final CTA */}
      <section className="bg-white py-14">
        <div className="container-custom max-w-2xl mx-auto text-center">
          <h2 className="font-serif text-3xl font-bold text-[#0f172a] mb-4">
            Klaar om te beginnen?
          </h2>
          <p className="text-[#64748b] mb-8">Start gratis en upgrade wanneer u wilt. Geen creditcard nodig voor de gratis versie.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/register"
              className="inline-flex items-center gap-2 font-bold px-8 py-4 rounded-xl text-lg transition-all shadow-lg"
              style={{ background: 'linear-gradient(135deg, #D4A017, #f5c842)', color: '#0f172a' }}>
              Start gratis scan <ArrowRight size={20} />
            </Link>
            <Link to="/register?upgrade=radar"
              className="inline-flex items-center gap-2 bg-[#0f172a] hover:bg-[#1e293b] text-white font-bold px-8 py-4 rounded-xl text-lg transition-all">
              Direct starten met Radar <Zap size={18} />
            </Link>
          </div>
          <p className="text-[#94a3b8] text-xs mt-4">Geen creditcard · Geen verplichtingen · Altijd opzegbaar</p>
        </div>
      </section>
    </>
  );
}
